import * as microsoftTeams from "@microsoft/teams-js";

// TO DO: this is no longer used, check if it can be removed
let inTeams = false;

export function initTeams() {
  return new Promise((resolve) => {
    microsoftTeams.initialize(() => {
      inTeams = true;
      microsoftTeams.getContext((context) => {
        resolve(context);
      });
    });
  });
}

export function getTeamsContext(): Promise<microsoftTeams.Context> {
  return new Promise((resolve) => {
    microsoftTeams.getContext((ctx) => {
      resolve(ctx);
    });
  });
}

export function isInTeams() {
  return inTeams || window.name === "extension-tab-frame";
}

export function successLoginTeams(data: string) {
  microsoftTeams.authentication.notifySuccess(data);
}

export function failedLoginTeams(reason: string) {
  microsoftTeams.authentication.notifyFailure(reason);
}

export function loginTeamsPopup() {
  return new Promise((resolve, reject) => {
    try {
      microsoftTeams.authentication.authenticate({
        url: `${window.location.origin}/teams-login-popup`,
        height: 500,
        width: 600,
        successCallback: (success) => {
          resolve(success);
        },
        failureCallback: (reason) => {
          reject(reason);
        }
      });
    } catch (e) {
      reject(e);
    }
  });
}
